<template>
  <div>
    <div class="mb-4 d-flex">
      <h4 class="title">Expenses ({{ results.length }})</h4>
    </div>
    <v-card class="elevation-1">
      <v-card-text>
        <div class="d-flex align-center mb-4">
          <v-menu offset-y bottom right v-if="options.showSelect" min-width="200px">
            <template v-slot:activator="{ on }">
              <v-btn outlined small v-on="on" class="mr-2" :disabled="updatingChanges">
                Action Items
                <v-icon small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-for="(item, index) in bulkActionItems"
                :key="index" @click="handleDropdown(item)">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn color="accent" class="mr-1"
            dark depressed small
            :disabled="updatingChanges"
            @click="onEdit({})"
          >Create Expense</v-btn>
          <v-btn text small icon color="accent" @click="init">
            <v-icon dark>mdi-refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </div>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="results"
          :search="search"
          :loading="loading"
          :show-select="options.showSelect"
          item-key="id"
          :loading-text="options.loadingText"
          :items-per-page="options.itemsPerPage"
        >
          <template v-slot:item.project="{ item }">
            {{ item.project.name }}
          </template>
          <template v-slot:item.reporter="{ item }">
            {{ item.reporter ? item.reporter.name : 'NA' }}
          </template>
          <template v-slot:item.budget="{ item }">
            {{ item.budget | currency('₹') }}
          </template>
          <template v-slot:item.expenseCode="{ item }">
            {{ item.expenseCode }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon :disabled="updatingChanges"
              small class="mx-1"
              @click="onEdit(item)"
            >mdi-pencil</v-icon>
            <v-icon
              :disabled="updatingChanges"
              small
              class="mx-1"
              @click="onDelete(item)"
            >mdi-delete-forever</v-icon>
          </template>
        </v-data-table>
        <v-dialog v-model="dialog" persistent max-width="480">
          <v-card>
            <v-card-title>
              <h4 class="title">{{ formHeading }}</h4>
            </v-card-title>
            <v-card-text>
              <expense-form v-if="dialog"
                @close="onClose"
                @save="onSave"
                :form-data="chosenItem">
              </expense-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import types from '@/store/types';
import ExpenseForm from '@/components/ExpenseForm.vue';

export default {
  name: 'expenses-list-page',
  components: {
    ExpenseForm,
  },
  data() {
    return {
      isvalid: false,
      dialog: false,
      chosenItem: null,
      loading: false,
      showSelect: false,
      selected: [],
      search: '',
      results: [],
      updatingChanges: false,
    };
  },
  computed: {
    ...mapState('tables', {
      headers: state => state.expensesTable.headers,
      options: state => state.expensesTable.options,
      bulkActionItems: state => state.expensesTable.bulkActionItems,
    }),
    formHeading() {
      return `${this.chosenItem && this.chosenItem.id ? 'Update' : 'Create'} Expense`;
    },
  },
  methods: {
    ...mapActions('db', {
      fetchResults: types.GET_EXPENSES,
      deleteItem: types.DELETE_EXPENSE,
      deleteSelected: types.DELETE_ALL_EXPENSES,
    }),
    noop() {},
    onClose() {
      this.dialog = false;
    },
    onSave() {
      this.dialog = false;
      this.loadResults();
    },
    onEdit(item) {
      this.chosenItem = {
        ...item,
      };
      this.dialog = true;
    },
    onDelete(item) {
      if (!item || !item.id) {
        return;
      }
      this.updatingChanges = true;
      this.deleteItem(item.id)
        .then(() => {
          const index = this.results.indexOf(item);
          this.results.splice(index, 1);
        }).catch(() => {})
        .finally(() => {
          this.updatingChanges = false;
        });
    },
    onMulitpleDelete() {
      if (!this.selected.length) {
        return;
      }
      this.updatingChanges = true;
      this.deleteSelected(this.selected)
        .then(() => {
          this.loadResults();
        }).catch(() => {})
        .finally(() => {
          this.updatingChanges = false;
        });
    },
    loadResults() {
      this.loading = true;
      this.fetchResults()
        .then((results) => {
          this.results = results;
        }).catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handleDropdown(item) {
      this[item.action]();
    },
    init() {
      this.loadResults();
    },
  },

  created() {
    this.init();
  },
};
</script>
